import * as React from "react";
import Card from "@mui/material/Card";
import Popover from "@mui/material/Popover";
import {
  Avatar,
  Badge,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import GradeIcon from "@mui/icons-material/Grade";

const TeamCard = ({ team, big = false }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <Card
      sx={{
        minWidth: big ? 200 : 120,
        maxWidth: big ? 200 : 120,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        padding: 1,
      }}
      aria-owns={open ? "mouse-over-popover" : undefined}
      aria-haspopup="true"
      onMouseEnter={handlePopoverOpen}
      onMouseLeave={handlePopoverClose}
    >
      <Avatar
        sx={{ width: big ? 100 : 32, height: big ? 100 : 32 }}
        alt={team.name}
        src={`/static/images/${team.avatarFileName}`}
      />
      <Typography sx={{ fontSize: big ? 20 : 12 }}>{team.name}</Typography>
      {team && team.members && team.members.length > 0 && (
        <Popover
          aria-hidden
          id="mouse-over-popover"
          sx={{ pointerEvents: "none" }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
          closeAfterTransition={true}
        >
          <TableContainer>
            <Table>
              <TableBody>
                {team.members.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell sx={{ display: "flex" }}>
                      {row.id !== team.teamCaptainId && (
                        <Avatar
                          sx={{
                            width: big ? 36 : 24,
                            height: big ? 36 : 24,
                            border:
                              row.id === team.teamCaptainId
                                ? "2px solid #4765a1"
                                : "",
                          }}
                          alt={row.nickname}
                          src={`/static/images/${
                            row.avatarFileName ?? "default.jpg"
                          }`}
                        />
                      )}
                      {row.id === team.teamCaptainId && (
                        <Badge
                          overlap="circular"
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          badgeContent={
                            <GradeIcon sx={{ fontSize: 12 }} color="primary" />
                          }
                        >
                          <Avatar
                            sx={{
                              width: big ? 36 : 24,
                              height: big ? 36 : 24,
                              border:
                                row.id === team.teamCaptainId
                                  ? "2px solid #4765a1"
                                  : "",
                            }}
                            alt={row.nickname}
                            src={`/static/images/${
                              row.avatarFileName ?? "default.jpg"
                            }`}
                          />
                        </Badge>
                      )}
                    </TableCell>
                    <TableCell>
                      <Typography sx={{ fontSize: big ? 20 : 12 }}>
                        {row.nickname}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography sx={{ fontSize: big ? 20 : 12 }}>
                        {row.fullName}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Popover>
      )}
    </Card>
  );
};

export default TeamCard;
